export default __webpack_public_path__ + "static/media/purchased.4d0fc471.jpg";